import { ellipsischar } from "../constants";
import { MeasureText } from "./MeasureText";

export function TruncateText(theText, fontString, maxWidth) {
  var lengthInPixels = MeasureText(theText, fontString);
  if (lengthInPixels <= maxWidth) return theText;

  var e = ellipsischar;
  var eLength = MeasureText(e, fontString);
  if (maxWidth < eLength) return e;

  var targetWidth = maxWidth - eLength;
  // Binary search for the longest prefix that fits
  var lo = 0;
  var hi = theText.length;
  while (lo < hi) {
    var mid = (lo + hi + 1) >>> 1;
    var sub = theText.substring(0, mid).trim();
    if (MeasureText(sub, fontString) <= targetWidth) {
      lo = mid;
    } else {
      hi = mid - 1;
    }
  }

  return theText.substring(0, lo).trim() + e;
}
